import { currentAccountId } from "services/authentication"

const walletPassUploadsUrl = (eventId: string) => `${import.meta.env.VITE_API_BASE}/api/v3/accounts/${currentAccountId()}/events/${eventId}/wallet_pass/uploads.json`

export default walletPassUploadsUrl
